/**
 * 목 보드용 Resources — 운영진이 올린 예시 파일 (team-files.js SEED 와 같은 목록, 1016 2차 수정 반영).
 * 파일은 받을 곳이 없어 url 이 비어 있고, 링크만 열린다. 최종 목록은 기획 문서를 따른다.
 */
const KB = 1024;
const MB = 1024 * 1024;

const file = (id, name, fileName, size, group, roles, extra = {}) => ({
  id,
  name,
  kind: 'file',
  fileName,
  size,
  url: null,
  linkType: null,
  group,
  roles,
  pinned: false,
  updatedAt: null,
  ...extra,
});
const link = (id, name, url, linkType, group, roles, extra = {}) => ({
  id,
  name,
  kind: 'link',
  fileName: null,
  size: null,
  url,
  linkType,
  group,
  roles,
  pinned: false,
  updatedAt: null,
  ...extra,
});

const ALL = ['PM', 'Designer', 'Developer'];

// 기본 파일 — Company materials 4 · Working files 5 · Templates 5 (예시 데이터, 최종은 기획 문서 기준)
export const MOCK_RESOURCES = [
  link('rf2', 'Current screens (as-is)', 'https://www.figma.com/', 'Figma', 'company', ALL),
  file('rf3', 'Current user flow (as-is)', 'current-user-flow.png', 640 * KB, 'company', ['PM']),
  file('rf4', 'Metrics snapshot (scenario numbers)', 'metrics-snapshot.png', 420 * KB, 'company', [
    'PM',
  ]),
  file('rf5', 'VOC / CS samples', 'voc-cs-samples.pdf', 1.8 * MB, 'company', ['PM', 'Designer']),
  // 한 항목에 파일 여러 개 — 토큰 css + 미리보기 그림
  file('rf6', 'Design guide to extend', 'design-tokens.css', 12 * KB, 'working', ['Designer'], {
    files: [
      { key: null, fileName: 'design-tokens.css', size: 12 * KB, url: null },
      { key: null, fileName: 'design-guide-preview.jpg', size: 860 * KB, url: null },
    ],
    updatedAt: '2026-10-16T00:40:00Z',
  }),
  file('rf11', 'Sample address data', 'sample-address-data.json', 24 * KB, 'working', [
    'Designer',
    'Developer',
  ]),
  file('rf12', 'Sample order data', 'sample-order-data.json', 36 * KB, 'working', [
    'Designer',
    'Developer',
  ]),
  file('rf13', 'Data spec (field guide)', 'data-spec.md', 8 * KB, 'working', ALL),
  file('rf14', 'Deploy guide', 'deploy-guide.md', 5 * KB, 'working', ['Developer']),
  file('rf15', 'PRD template', 'prd-template.md', 4 * KB, 'templates', ['PM']),
  file('rf16', 'QA report template', 'qa-report-template.md', 3 * KB, 'templates', ['PM']),
  file('rf17', 'One-page summary · 4 questions', 'one-page-summary.md', 2 * KB, 'templates', [
    'PM',
  ]),
  file('rf18', 'README template · open-source list', 'readme-template.md', 2 * KB, 'templates', [
    'Developer',
  ]),
  file('rf19', 'Figma sharing guide', 'figma-sharing-guide.md', 3 * KB, 'templates', ['Designer']),
];
